// Detects if user was finding the action vs searching for entity
// Prevents "search for 'search'" UX issue
export const detectSearchIntent = (action: { title: string }, query: string): boolean => {
  if (!query) return false;

  const lowerQuery = query.toLowerCase();
  const matchedTitle = action.title.toLowerCase().includes(lowerQuery);

  return !matchedTitle;
};
